// NEW_STATS Brand Score blend: New Brand Score = 0.6 × current Brand Score + 0.4 × Visibility.
// Both inputs are 0–100 percentages. Single source of truth for the formula — used by the V2 preview
// page (tile / chart line / Brands ranking) and the projects-list KPI column. Falls back to the raw
// brand score when visibility is missing/non-numeric (so a bucket/row without visibility doesn't dip),
// and returns the input unchanged when the brand score itself is missing.
export const BRAND_SCORE_WEIGHT = 0.6;
export const VISIBILITY_WEIGHT = 0.4;

export const blendBrandScore = (
  brandScore: string | number | null | undefined,
  visibility: string | number | null | undefined
): string | number | null | undefined => {
  const bs = Number(brandScore);
  if (brandScore === null || brandScore === undefined || brandScore === '' || Number.isNaN(bs)) {
    return brandScore;
  }
  const vis = Number(visibility);
  if (visibility === null || visibility === undefined || visibility === '' || Number.isNaN(vis)) {
    return brandScore;
  }
  return Math.round((BRAND_SCORE_WEIGHT * bs + VISIBILITY_WEIGHT * vis) * 10) / 10;
};
